/* eslint-disable */

import psImgNav from "../images/paysimply/PaySimply-nav.png";
import zwImgNav from "../images/zenwallet/Zenwallet-nav.png";

import zwIco from "../pages/dynamicPages/favicon/zenwallet.ico";
import psIco from "../pages/dynamicPages/favicon/paysimply.ico";
import psiIco from "../pages/dynamicPages/favicon/psi.ico";

import paySimply from "../images/paysimply/Paysimply-color-desktop.png";
import zenWallet from "../images/zenwallet/Zenwallet-color-desktop.png";

import paySimplyMobile from "../images/paysimply/Paysimply-color-mobile.png";

import ps from "../images/widget/Paysimply-color-mobile.png";
import zw from "../images/widget/Zenwallet-color-mobile.png";

import paymentSourceLogo from "../images/paymentsourcelogo_colour-1.png";
import paymentSourceLogoDesktop from "../images/paymentSource/paymentSourceLogo_Desktop.png";
import paymentSourceLogoMobile from "../images/paymentSource/paymentSourceLogo_Mobile.png";
import { isDevelopment } from "../helperFunctions/config";
import { t } from "react-switch-lang";

export const brandConfig = Object.freeze({
  // PaySimply
  paysimply: {
    name: "PaySimply",
    sqlName: "PaySimply",
    languages: ["en", "fr"],
    text: {
      navBar: {
        link: "Link_PaySimply",
        text: "Navbar_Paysimply",
      },
      footer: {
        tcLink: "Link_PaySimplyTerms",
        privacyLink: "Link_PaySimplyPrivacy",
      },
    },
    footerLink: [
      ["Footer_Terms_And_Condition", "Link_PaySimplyTerms"],
      ["Footer_Privacy_Policy", "Link_PaySimplyPrivacy"],
      ["Footer_Accessibility", "Link_AccessibilityStatement"],
    ],
    theme: {
      logo: psImgNav,
      logoAltText: "Paysimply",
      bkgColor: "#bb1b20",
      fontColor: "rgba(255, 255, 255, 1)",
      langnumber: "mr-1 langdrop1",
      navclass: "paysimplyNavClass",
      contactForm: {
        radioColor: "#2b4e7b",
        radioTextColor: "#2b4e7b",
        radioSelectedTextColor: "#ffffff",
        buttonColor: "#2b4e7b",
        buttonTextColor: "#ffffff",
      },
    },
    genesysDeploymentKey: "",
    favicon: psIco,
    homePage: {
      link: "paysimply/en/categories",
      imageDesktop: paySimply,
      imageMobile: paySimplyMobile,
    },
    widgetMode: {
      theme: {
        backgroundColor: "#bb1b20",
        color: "rgba(255, 255, 255, 1)",
      },
      image: ps,
    },
    mobileMode: {
      endChatBtn: {
        light: "#2b4e7b",
        dark: "#a5c3ea",
      },
    },
  },

  // Zenwallet
  zenwallet: {
    name: "Zenwallet",
    sqlName: "Zenwallet",
    languages: ["en", "fr"],
    text: {
      navBar: {
        link: "Link_ZenwalletMain",
        text: "Navbar_Zenwallet",
      },
    },
    footerLink: [
      ["Footer_Terms_And_Condition", "Link_Zenwallet_Terms"],
      ["Footer_Privacy_Policy", "Link_PaySimplyPrivacy"],
      ["Footer_Accessibility", "Link_AccessibilityStatement"],
    ],
    theme: {
      logo: zwImgNav,
      logoAltText: "Zenwallet",
      bkgColor: "#1B1C1D",
      fontColor: "rgba(255, 255, 255, 0.644)",
      langnumber: "mr-1 langdrop4",
      navclass: "zenwalletNavClass",
      contactForm: {
        radioColor: "#73b842",
        radioTextColor: "#000000",
        radioSelectedTextColor: "#000000",
        buttonColor: "#73b842",
        buttonTextColor: "#000000",
      },
    },
    genesysDeploymentKey: "",
    favicon: zwIco,
    homePage: {
      link: "zenwallet/en/categories",
      imageDesktop: zenWallet,
      imageMobile: zenWallet,
    },
    widgetMode: {
      theme: {
        backgroundColor: "#5e9636",
        color: "black",
      },
      image: zw,
    },
    mobileMode: {
      endChatBtn: {
        light: "#59952e",
        dark: "#73b842",
      },
    },
  },

  partners: {
    name: "Payment Source Partners",
    sqlName: "Partners",
    languages: ["en", "fr"],
    text: {
      navBar: {
        link: "",
        text: "",
      },
      footer: {
        tcLink: "Link_PaySimplyTerms",
        privacyLink: "Link_PaySimplyPrivacy",
      },
    },
    footerLink: [
      ["Footer_Privacy_Policy", "Link_PaySimplyPrivacy"],
      ["Footer_Accessibility", "Link_AccessibilityStatement"],
    ],
    theme: {
      logo: paymentSourceLogo,
      logoAltText: "Payment Source Partners",
      logoDisplayText: "HomePage_BrandTitle_Partners",
      logoDisplayTextColor: "#02464e",
      bkgColor: "#ffffff",
      fontColor: "#555556",
      langnumber: "mr-1 langdrop1",
      navclass: "paymentSourceNavClass",
      footerBackgroundColor: "#002D33",
      contactForm: {
        radioColor: "#02464e",
        radioTextColor: "#02464e",
        radioSelectedTextColor: "#ffffff",
        buttonColor: "#02464e",
        buttonTextColor: "#ffffff",
      },
    },
    genesysDeploymentKey: "",
    favicon: psiIco,
    homePage: {
      link: "partners/en/categories",
      imageDesktop: paymentSourceLogoDesktop,
      imageMobile: paymentSourceLogoMobile,
      style: { padding: "0" },
      cardTitleKey: "HomePage_BrandTitle_Partners",
      imageAltTag: "HomePage_Brand_Partners_ImageDescription",
    },
    widgetMode: {
      theme: {
        backgroundColor: "#00444d",
        color: "white",
      },
      image: paymentSourceLogo,
    },
    mobileMode: {
      endChatBtn: {
        light: "",
        dark: "",
      },
    },
  },

  payments: {
    name: "Payment Source Payments",
    sqlName: "Payments",
    languages: ["en", "fr"],
    text: {
      navBar: {
        link: "",
        text: "",
      },
      footer: {
        tcLink: "Link_PaySimplyTerms",
        privacyLink: "Link_PaySimplyPrivacy",
      },
    },
    footerLink: [
      ["Footer_Privacy_Policy", "Link_PaySimplyPrivacy"],
      ["Footer_Accessibility", "Link_AccessibilityStatement"],
    ],
    theme: {
      logo: paymentSourceLogo,
      logoAltText: "Payment Source Partners",
      logoDisplayText: "HomePage_BrandTitle_Payments",
      logoDisplayTextColor: "#02464e",
      bkgColor: "#ffffff",
      fontColor: "#555556",
      langnumber: "mr-1 langdrop1",
      navclass: "paymentSourceNavClass",
      footerBackgroundColor: "#002D33",
      contactForm: {
        radioColor: "#02464e",
        radioTextColor: "#02464e",
        radioSelectedTextColor: "#ffffff",
        buttonColor: "#02464e",
        buttonTextColor: "#ffffff",
      },
    },
    genesysDeploymentKey: "",
    favicon: psiIco,
    homePage: {
      link: "payments/en/categories",
      imageDesktop: paymentSourceLogoDesktop,
      imageMobile: paymentSourceLogoMobile,
      style: { padding: "0" },
      cardTitleKey: "HomePage_BrandTitle_Payments",
      imageAltTag: "HomePage_Brand_Payments_ImageDescription",
    },
    widgetMode: {
      theme: {
        backgroundColor: "#00444d",
        color: "white",
      },
      image: paymentSourceLogo,
    },
    mobileMode: {
      endChatBtn: {
        light: "",
        dark: "",
      },
    },
  },

});
// eslint-disable-next-line no-prototype-builtins
export const checkBrandExists = (brand) => brandConfig.hasOwnProperty(brand);

export const nppBrands = ["topmeup", "nowprepay"];

export const isNppBrand = (brand) => nppBrands.includes(brand.toLowerCase());

export const nppDomain = () => {
  return (isDevelopment() ? "https://help.nppdev.net" : "https://help.nowprepay.net");
}

export const checkBrandLangExists = (brand, lang) =>
  brandConfig[brand]?.languages.includes(lang) ?? false;

export const brandFaviconGet = (brand) => brandConfig[brand]?.favicon;

export const brandTitleGet = (brand, lang = "en") =>
  brandConfig[brand]?.screenReader?.[lang] ??
  brandConfig[brand]?.sqlName ??
  "Default";

export const getSqlBrand = (brand) => brandConfig[brand].sqlName;

export function brandKeyGetByName(name) {
  // eslint-disable-next-line no-restricted-syntax
  for (const brand in brandConfig) {
    if (brandConfig[brand].sqlName === name) return brand;
  }
  return null;
}

export const getAllBrands = () => Object.keys(brandConfig);

export const checkTypeExist = (type) => {
  return helpType.includes(type);
};

export const helpType = [
  "categories",
  "sections",
  "articles",
  "contactus",
  "category",
  "section",
  "article",
];

export const languageText = Object.freeze({
  en: "English",
  fr: "Français",
  zh: "中文",
  ko: "한국어",
});

/*If widget > show does not exist for brand, then true */
export const showWidget = (brand) =>
  brandConfig[brand]?.widgetMode?.show ?? true;

export const getFooterLinkColor = (brand) =>
  brandConfig[brand]?.theme.footerFontColor ?? "#e8e8e8";

export const getFooterBorderTop = (brand) =>
  brandConfig[brand]?.theme.footerBorderTop ?? "";

export const getAccessibilityName = (brand, lang) => {
  if (brandConfig[brand]?.homePage.imageAltTag) {
    return t(brandConfig[brand]?.homePage.imageAltTag, null, lang);
  } else {
    return brandConfig[brand].name;
  }
};

export const getFooterBackgroundColor = (brand) =>
  brandConfig[brand]?.theme.footerBackgroundColor ?? "#222222";

export const getHomePageLogoStyle = (brand) =>
  brandConfig[brand]?.homePage.style ?? null;

export const getLogoDisplayText = (brand) =>
  brandConfig[brand]?.theme.logoDisplayText ? t(brandConfig[brand]?.theme.logoDisplayText) : "";

export const getFontColor = (brand) =>
  brandConfig[brand]?.theme.fontColor ?? "black";

export const getLogoDisplayTextColor = (brand) =>
  brandConfig[brand]?.theme.logoDisplayTextColor ?? getFontColor(brand);

const defaultContactFormTheme = Object.freeze({
  radioColor: "#2b4e7b",
  radioTextColor: "#2b4e7b",
  radioSelectedTextColor: "#ffffff",
  buttonColor: "#2b4e7b",
  buttonTextColor: "#ffffff",
});

export const getContactFormTheme = (brand) => ({
  ...defaultContactFormTheme,
  ...brandConfig[brand]?.theme.contactForm,
});

export const getContactFormStyle = (brand) => {
  const theme = getContactFormTheme(brand);

  return {
    "--contact-radio-color": theme.radioColor,
    "--contact-radio-text-color": theme.radioTextColor,
    "--contact-radio-selected-text-color": theme.radioSelectedTextColor,
    "--contact-button-color": theme.buttonColor,
    "--contact-button-text-color": theme.buttonTextColor,
  };
};
